/**
 * @file Supabase client initialization (npm import, singleton)
 */

import { createClient } from '@supabase/supabase-js';
import { config } from '@core/config.js';

let client = null;
let ready = false;

/**
 * Initialize the Supabase client (call once on startup).
 */
export function initSupabase() {
  if (client) return client;
  client = createClient(config.supabase.url, config.supabase.anonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: false,
    },
  });
  ready = true;
  return client;
}

/**
 * Get the Supabase client instance.
 * @returns {import('@supabase/supabase-js').SupabaseClient}
 */
export function getClient() {
  if (!client) initSupabase();
  return client;
}

/**
 * Check if the Supabase client is initialized and ready.
 * @returns {boolean}
 */
export function isReady() {
  return ready;
}
